import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import { TooltipWidget } from '@components/widgets/TooltipWidget';
import { useTranslationText } from '@translation/hooks/use-translation-text';
import { LinkifiedText } from '@components/LinkifiedText';

export default function LocalTranslatedText({
  text,
  showOptionToViewOriginalLanguage,
  enableLinkification = true,
}) {
  const { language } = useLanguage();
  const languageCode = language.split('-')[0];

  const { translated, isTranslated, isLoading } = useTranslationText(
    text,
    languageCode
  );

  if (!text || typeof text !== 'string') return text;

  if (isLoading) {
    return (
      <span className="pui-text-label-xs pui-font-medium pui-text-text-secondary">
        ...
      </span>
    );
  }

  // Determine the text to display (translated or original)
  const displayText = isTranslated ? translated : text;

  // Helper to render text with optional linkification
  const renderText = (content) => {
    if (enableLinkification) {
      return <LinkifiedText text={content} />;
    }
    return content;
  };

  if (isTranslated) {
    if (showOptionToViewOriginalLanguage) {
      return (
        <TooltipWidget content={text}>
          <span className="pui-text-p-sm pui-text-text-primary">
            {renderText(displayText)}
          </span>
        </TooltipWidget>
      );
    }

    return renderText(displayText);
  }

  return renderText(displayText);
}
